//EOMS-362 let die ddq silent in case tealium is blocked and no core is included or tealium is expected as object.
var DDQ = /*@__PURE__*/ (function () {
    function DDQ() {
    }
    DDQ.push = function (data) {
        try {
            window._ddq.push(data);
        }
        catch (e) {
            //throw new Error('Cannot add data to tealium it does not exist');
        }
    };
    DDQ.on = function (evt, callback) {
        try {
            window._ddq.on(evt, callback);
        }
        catch (e) {
            // throw new Error('Cannot add data to tealium it does not exist');
        }
    };
    return DDQ;
}());
export { DDQ };



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/api/utils/ddq.ts
// module id = null
// module chunks = 